import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import ApplicationContent from './ApplicationContent';
import useDebounce from '../../../../../common/components/UseDebounce';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function ApplicationContainer({
  match,
  history,
  getSettings,
  settingsList,
  settingsListPager,
  isLoading,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Application Settings',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getSettings();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getSettings({ q: formData.keyword, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:settingId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Application Settings"
            getData={getSettings}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:settingId?`}
            listName="Application Settings"
            label="Application Settings List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <span style={{ color: '#2f89fc', fontWeight: 'bold' }}>
                  {_.get(item, 'attributes.name')}{' '}
                </span>
              </div>
            )}
            isLoading={isLoading}
            selected={params.settingId}
            data={settingsList}
            dataPager={settingsListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:settingId?`}
                    render={() => (
                      <ApplicationContent
                        handleEdit={handleEdit}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:settingId?`}
                  render={() =>
                    !params.settingId && settingsList.length > 0 ? (
                      <Redirect to={`${match.url}/${_.get(settingsList, '0.id')}`} />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

ApplicationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  settingsList: PropTypes.instanceOf(Array).isRequired,
  settingsListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  settingsList: _.get(api, `${c.GET_SETTINGS}.list`) || [],
  settingsListPager: _.get(api, `${c.GET_SETTINGS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_SETTINGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContainer);
